import { isObject, isRegex } from '@toolbox/utils';

import type { ValidationValue, ValidationValueMessage } from 'react-hook-form/dist/types/validator';
import type { ValidationRule } from 'react-hook-form';

export const getValueAndMessage = <T extends ValidationValue = ValidationValue>(
  validationData?: ValidationRule,
): ValidationValueMessage<T> =>
  isObject(validationData) && !isRegex(validationData)
    ? (validationData as ValidationValueMessage<T>)
    : {
        value: validationData as T,
        message: '',
      };
